const initialState = {
  show: false,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_HEADER_HIDE": {
      return {
        ...state,
        show: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
